import module from '../module';
import { ChangePasswordController } from "../controllers/ChangePasswordController";
import CommonConstants from "../../../utils/CommonConstants";
import {utils} from "../../../utils/shopifyInjector/utils";

export class AuthenticationService {
  static $inject = ['$http', '$timeout', 'Session', 'LocalForageService', 'cartonomyConfig', '$mdDialog', '$q', 'CartService', 'Message', '$window', '$state', '$rootScope'];

  constructor(httpService, timeoutService, sessionService, localForageService, cartonomyConfig, dialogService, qService, cartService, messageService, windowService, stateService, rootScope) {

    this._urlBase = cartonomyConfig.ApiV2 + 'authentication/';
    this._urlUserBase = cartonomyConfig.ApiV2 + 'user/';
    this._sessionService = sessionService;
    this._httpService = httpService;
    this._dialogService = dialogService;
    this._qService = qService;
    this._cartService = cartService;
    this._messageService = messageService;
    this._windowService = windowService;
    this._stateService = stateService;
    this._loginPromise = null;
    this._cartonomyConfig = cartonomyConfig;
    //this._sessionStorageService = sessionStorageService;
    this._localForageService = localForageService;
    this._timeout = timeoutService;
    this._rootScope = rootScope;
    this.checkLoginToken();
  }

  async checkLoginToken() {
      if (await this._sessionService.loggedIn()) {
          let bearer = await this._sessionService.getAuthToken();
          this.authToken = bearer;
      }
  }

  async _updateSession(data) {
    const payload = {
      authToken: data.authToken,
      userEmail: data.user.userName,
      userName: data.user.fullName,
      firstName: data.user.firstName,
      lastName: data.user.lastName,
      email: data.user.email
    };

    await this._sessionService.setSessionDetails(payload);
  }

  waitForLogin(onlySuccessful) {
    return new Promise(resolve => {
      if (!this._loginPromise) {
        resolve();
      } else {
        if (onlySuccessful) {
          this._loginPromise.then(() => resolve());
        } else {
          this._loginPromise.finally(() => resolve());
        }
      }
    });
  }

  async showLoginDialog(email, currentPage, createOrderFlow, invitedCart) {
    if (this.isLoggingIn)
      return this.isLoggingIn;
    this._rootScope.$broadcast(CommonConstants.Events.DIALOG_OPENED, false);
    let self = this;
    this.isLoggingIn = await this._dialogService.show({
      controller: 'Cartonomy.Shared.LoginController',
      templateUrl: 'modules/shared/views/loginDialog.html',
      clickOutsideToClose: false,
      escapeToClose: false,
      focusOnOpen: false,
      locals: {
        email: email,
        currentPage: currentPage,
        createOrderFlow: createOrderFlow,
        invitedCart: invitedCart
      },
      onRemoving: function (event, removePromise) {
        self._rootScope.$broadcast(CommonConstants.Events.DIALOG_CLOSED);
      }
    });

    this.isLoggingIn = null;
  }

  showSignupDialog(email) {
    return this.showLoginDialog(email, 'signup');
  }

  showChangePasswordDialog() {
    return this._dialogService.show({
      controller: ChangePasswordController,
      template: require('../views/changePasswordDialog.pug'),
      clickOutsideToClose: true
    });
  }

  _prepareNewCart(cart) {

    if (!cart.items || cart.items.length === 0) {
      return null;
    }

    return {
      items: cart.items.map(item => {
        return {
          catalogProductId: item.catalogProductId,
          quantity: item.quantity,
          comment: item.comment
        };
      })
    };
  }

  async externalLoginFinalize(authToken) {
    let cart = await this._cartService.getCart();
    const newCart = this._prepareNewCart(cart);
    try{
      await this._httpService
          .post(this._urlBase + 'externalLoginFinalize', {
            cart: newCart,
            authToken: authToken
          });
    } catch (e) {
      console.log(e);
    }
  }

  loginRequest(credentials, ignoreLocalCart) {

    if (this._loginPromise) {
      return this.waitForLogin().then(() => this.loginRequest(credentials));
    }

    this._loginPromise = this._doLogin(credentials, ignoreLocalCart).then(undefined, error => {
      this._loginPromise = null;
      return new Promise((resolve, reject) => reject(error));
    });

    return this._loginPromise;
  }

  async _doLogin(credentials, ignoreLocalCart) {

    let leaveInvite = false;

    if (await this._sessionService.isInvite()) {
      leaveInvite = ignoreLocalCart;
      ignoreLocalCart = true;
    }

    let cart = await this._cartService.getCart();

    const newCart = ignoreLocalCart ? null : this._prepareNewCart(cart);

    if (leaveInvite) {
      await this._sessionService.clearSessionDetails();
    }

    const res = await this._httpService
      .post(this._urlBase + 'login', {
        username: credentials.username,
        password: credentials.password,
        cart: newCart
      });

    await this._cartService.clearLocalCart();
    this._sessionService.setCachedUser(null);
    await this._updateSession(res.data);
    await this._cartService.resetCart();
    this._loginPromise = null;
    return res.data.user;
  }

  async ensureLoggedIn() {

    if (!(await this._sessionService.loggedIn())) {
      return this.showLoginDialog();
    }

    return this._qService.resolve();
  }

  async logout() {

    if (this._loginPromise) {
      await this.waitForLogin();
      this.logout();
      return;
    }

    if (!(await this._sessionService.loggedIn())) {
      return;
    }

    await this._httpService.post(this._urlBase + 'logout');

    this._sessionService.setCachedUser(null);
    this._sessionService.setStealthUserMode(null);
    this._cartService.resetCart();

    await this._localForageService.clear();

    this.authToken = null;
    this._loginPromise = null;
  }

  async register(registration, ignoreLocalCart) {

    if (await this._sessionService.isInvite()) {
      ignoreLocalCart = true;
    }

    let cart = await this._cartService.getCart();

    let res = await this._httpService.post(this._urlBase + 'register', {
      email: registration.email,
      password: registration.password,
      firstName: registration.firstName,
      lastName: registration.lastName,
      fullName: registration.fullName,
      confirmPassword: registration.password,
      cart: ignoreLocalCart ? null : this._prepareNewCart(cart)
    });

    await this._cartService.clearLocalCart();
    this._sessionService.setCachedUser(null);
    await this._updateSession(res.data);
    this._cartService.resetCart();
    this._loginPromise = null;
    return res.data.user;
  }

  async checkIfEmailCanRegister(email) {
    return await this._httpService.post(this._urlBase + 'canEmailRegister', {
      email: email
    });
  }

  async loginWithInviteToken(inviteDetails) {
    inviteDetails.isInvite = true;
    await this._sessionService.clearSessionDetails();
    await this._sessionService.setSessionDetails(inviteDetails);
    this._sessionService.setCachedUser(null);
    this._sessionService.setCartReference(null);
  }

  onInviteAccepted() {
    this._sessionService.setCachedUser(null);
    this._sessionService.setCartReference(null);
  }

  externalLogin(provider) {
    const location = this._windowService.location;
    let redirectUri = location.origin + location.pathname;

    if (location.pathname === '/') {
      redirectUri += 'index.html';
    }

    let href = `${this._cartonomyConfig.ApiV2}oauth/${provider}?`;

    if (this.authToken) {
        href += `&authenticationToken=${this.authToken}`;
    }

    if (!href.startsWith('https') || !href.startsWith('http')) {
      href = location.origin + href;
    }

    href += `&redirectUrl=${encodeURI(redirectUri)}`;
    return href;
  }

  async validatePasswordTicket(ticket, password) {

    const response = await this._httpService.post(this._urlUserBase + 'password/reset', {
      resetToken: ticket,
      password: password,
      confirmPassword: password
    });

    if (response.data.result !== 'failure') {
      return {
        success: true
      };
    }

    if (response.data.errors && response.data.errors.length) {
      return {
        success: false,
        errorMessage: response.data.errors[0].errorMessage
      };
    }

    return {
      success: false
    };
  }

  sendValidateRequest(email) {
    return this._httpService.post(this._urlUserBase + 'password/recover', {
      username: email
    });
  }

  changePassword(oldPassword, newPassword) {
    return this._httpService.post(this._urlUserBase + 'changepassword', {
      password: newPassword,
      confirmPassword: newPassword
    });
  }

  getOpenIdProviders() {
    return [
      {
        id: 'facebook',
        title: 'Facebook',
        color: '#4267B2',
        provider: 'Facebook',
        icon: 'fa-facebook',
        svgIcon: 'resources/icons/social/facebook-logo.svg',
      },
      {
        id: 'google+',
        title: 'Google+',
        color: '#da4a27',
        icon: 'fa-google-plus',
        provider: 'Google'
      }
    ];
  }


}

module.service('AuthenticationService', AuthenticationService);




// WEBPACK FOOTER //
// ./src/modules/shared/services/AuthenticationService.js